/* Al Muqaddima theme — minimal interactivity */
(function () {
  'use strict';

  // Mobile navigation toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // Close the menu after tapping a link
    mobileNav.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileNav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Variant selection reloads the page with ?variant=<id>.
  //
  // The price and the SPD Split Payment widget are both rendered from Liquid's
  // `selected_or_first_available_variant`, and SPD targets the Live cohort variants
  // specifically. Swapping the variant client-side would leave a stale price and an
  // installment widget attached to a variant the app does not cover, so re-render
  // server-side instead. Single-variant products submit a hidden input and are skipped.
  var variantSelect = document.getElementById('variant-id');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('variant', variantSelect.value);
      window.location.search = params.toString();
    });
  }

  // Smooth scroll for in-page anchor pills
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();
